import { render, staticRenderFns } from "./qualification-officers-details.vue?vue&type=template&id=8fb4186c&scoped=true"
import script from "./qualification-officers-details.vue?vue&type=script&lang=js"
export * from "./qualification-officers-details.vue?vue&type=script&lang=js"
import style1 from "./qualification-officers-details.vue?vue&type=style&index=1&id=8fb4186c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb4186c",
  null
  
)

export default component.exports